import React, { useState } from "react";
import { withRouter } from "react-router";
import { useSubmit } from "./hooks/useSubmit";
import { useForm } from "./hooks/useForm";
import { useEfaxText } from "./hooks/useEfaxText";
import { useTemplateForm } from "./hooks/useTemplateForm";
import TemplateForm from "./components/TemplateForm";
import AddFaxForm from "./components/AddFaxForm";
import { useEfaxCheckPagesMutation } from "../../../../../api/efax/useEfaxCheckPagesMutation";
import { Modal } from "../../../../../shared/Modal/Modal";
import { Button } from "../../../../../shared/Button/Button";

const ModalAdd = ({ onClose, match }) => {
  const [showTemplateForm, setShowTemplateForm] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const clientId = match.params.clientID;

  const form = useForm(() => {
    text.refetch();
  }, clientId);

  const text = useEfaxText(
    {
      patientId: clientId || form.patient.value?.value,
      clinicId: form.clinic.value?.value,
      senderId: form.user.value?.value,
      labTestIds: form.checkedTests.value,
      favoriteId: form.favorites.value.value,
      defaultTemplate: Number(form.makeDefault.value),
      templateId:
        form.template.value?.value === 0 ? null : form.template.value?.value,
    },
    {
      enabled: false,
      onSuccess: (data) => {
        setShowTemplateForm(true);
        content.onChange(data.data?.data?.text);
      },
    },
  );

  const submit = useSubmit();
  const { content } = useTemplateForm();
  const checkPages = useEfaxCheckPagesMutation();

  const handleSubmitTemplate = () => {
    // If there are attachments, check pages first
    if (form.attachments.value && form.attachments.value.length > 0) {
      checkPages.mutate(form.attachments.value, {
        onSuccess: (response) => {
          const pageCount = response.data?.data?.total_pages || 0;
          setTotalPages(pageCount);
          setShowConfirmation(true);
        },
        onError: () => {
          // If check-pages fails, still allow sending without confirmation
          proceedWithSend();
        },
      });
    } else {
      // No attachments, send directly
      proceedWithSend();
    }
  };

  const proceedWithSend = () => {
    submit
      .initiate({
        clinicId: form.clinic.value?.value,
        senderId: form.user.value?.value,
        faxNumber: form.faxNumber.value,
        patientId: parseInt(clientId) || form.patient.value?.value,
        text: content.value.value,
        templateId:
          form.template.value?.value === 0 ? null : form.template.value?.value,
        attachments: form.attachments.value,
      })
      .then(onClose);
  };

  const handleConfirmSend = () => {
    setShowConfirmation(false);
    proceedWithSend();
  };

  return (
    <>
      {showTemplateForm ? (
        <TemplateForm
          form={form}
          content={content}
          setShowTemplateForm={setShowTemplateForm}
          onClose={onClose}
          submit={handleSubmitTemplate}
          isLoading={submit.isLoading || checkPages.isLoading}
          clientId={clientId}
        />
      ) : (
        <AddFaxForm
          form={form}
          isLoading={text.isFetching || text.isRefetching}
          onClose={onClose}
          clientId={clientId}
        />
      )}

      {showConfirmation && (
        <Modal
          isOpen
          onClose={() => setShowConfirmation(false)}
          shouldCloseOnOverlayClick={false}
          header={<Modal.Title>Confirm eFax Order</Modal.Title>}
          footer={
            <div className="flex justify-end gap-10">
              <Button
                variant="outlined"
                onClick={() => setShowConfirmation(false)}
                className="m-r-10"
              >
                Cancel
              </Button>
              <Button onClick={handleConfirmSend} isDisabled={submit.isLoading}>
                Continue
              </Button>
            </div>
          }
        >
          <div className="p-20">
            <p>
              Your eFax order includes a total of <strong>{totalPages}</strong>{" "}
              attached pages. These pages will be deducted from your eFax
              available balance once the order is sent. If your available credit
              is insufficient, you will be charged for the additional pages.
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};
export default withRouter(ModalAdd);
